import { render, staticRenderFns } from "./CreateMemoIcon.vue?vue&type=template&id=fe1ecb06&"
import script from "./CreateMemoIcon.vue?vue&type=script&lang=ts&"
export * from "./CreateMemoIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports